export function convertDentsToWidthInMeter(dents: number, reedDensityInDentsPerMeter: number): number {
  return reedDensityInDentsPerMeter > 0.0 ? dents / reedDensityInDentsPerMeter : 0.0;
}
